import { computed, defineComponent, onMounted, reactive, ref, useCssModule, watch } from '@nuxtjs/composition-api';
import { SCRIPT_SRC } from './';
import { ADFOX_FETCH_STATES } from '~/components/Adfox';
const TYPE = 'a';
export default defineComponent({
    name: 'Sparrow',
    emits: ['complete'],
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const bannerEl = ref();
        const error = reactive({});
        const state = reactive({ ...ADFOX_FETCH_STATES });
        const configA = {
            script_key: 'd242f1a255d1bbb7e3a31d8b1f2fc901',
            settings: {
                w: 16608,
                sid: 10859,
            },
        };
        const configB = {
            script_key: '4d3416f98cb21a9d46d59d2bce5be36b',
            settings: {
                w: 18895,
                sid: 10859,
            },
        };
        const config = computed(() => {
            return TYPE === 'a' ? configA : configB;
        });
        function initSparrow() {
            state.isLoaded = true;
            window._svk_n_widgets = window._svk_n_widgets || [];
            window._svk_n_widgets.push({ ...config.value });
            if (!window._SVKNative_embed) {
                return throwError(`There is no '_SVKNative_embed' in window`);
            }
            window._SVKNative_embed.initWidgets();
            state.isRendered = true;
            state.isCompleted = true;
            emit('complete', { error, state });
        }
        function throwError(message = '', payload = '') {
            state.withError = true;
            error.message = message;
            console.error('[Sparrow]', message, payload);
        }
        watch(() => config.value, () => {
            const sparrowRoot = bannerEl.value?.firstChild;
            const script = document.createElement('script');
            script.dataset.key = config.value.script_key;
            bannerEl.value?.replaceChild(script, sparrowRoot);
            initSparrow();
        });
        onMounted(() => {
            const scriptEl = document.head.querySelector(`script[src="${SCRIPT_SRC}"]`);
            if (scriptEl) {
                initSparrow();
            }
            else {
                const script = document.createElement('script');
                script.async = true;
                script.src = SCRIPT_SRC;
                script.onerror = () => {
                    return throwError(`Error in script "${SCRIPT_SRC}"`);
                };
                script.onload = () => initSparrow();
                document.head.append(script);
            }
        });
        return {
            TYPE,
            bannerEl,
            config,
            css,
            error,
            state,
        };
    },
});
